import axios from 'axios'
import { getApiUrls } from "@/http/base.http";

export function getExportData(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/export/data`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddSubmitId() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/archival/submitid/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function viewExportData(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/export/data/view`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function fileStatus(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/export/file/status`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddFile(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dropdown/archival/file/dd`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddRoot() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/archival/dest/root/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddFolder(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dropdown/archival/dest/folder/dd`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}


export function DownloadArchivalReportData(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/file/download`, payload, {
        responseType: 'blob'
    });
}


// export function DownloadArchivalReportData(payload) {
//     const { env } = getApiUrls();
//     return axios.post(`${env}archival/file/download`, payload, {
//     responseType: 'blob'
//   }).then(res => {
//         axios.defaults.baseURL = res.data
//         return res.data
//     })
// }